<template>
  <div class="title-bubble" :class="{large: text.length > 4 && text.length <= 6, xl: text.length > 6}">
    <span class="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "TitleBubble",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@s/common.scss";

.title-bubble {
  background: url(../../../assets/ceping114/title_bubble_bg.png) 0 0 no-repeat;
  background-size: 100% 1.44rem;
  height: 1.44rem;
  width: 2.854rem;
  position: absolute;
  left: 0;
  top: -0.48rem;
  padding-bottom: 0.48rem;
  text-align: center;
  font-size: 0.48rem;

  &.large {
    width: 3.07rem;
    font-size: 0.37rem;
  }

  &.xl {
    width: 3.87rem;
    font-size: 0.37rem;
  }

  .text {
    color: #FEFEFB;
    font-weight: bold;
    white-space: nowrap;
    line-height: 0.96rem;
  }
}
</style>